import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const TochtTypeApi = {
	getTochtTypes() {
		const serviceUrl = prependRoot("/tochttype", getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default TochtTypeApi;
